export default __webpack_public_path__ + "static/media/stellar.0aec4bba.png";